import { render, staticRenderFns } from "./activityManageExamsRevamped.html?vue&type=template&id=aabf5af0&external"
import script from "./activityManageExamsRevamped.vue?vue&type=script&lang=js"
export * from "./activityManageExamsRevamped.vue?vue&type=script&lang=js"
import style0 from "./activityManageExamsRevamped.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports